
import { useLoaderData } from "react-router-dom";
import PageTitle from "../ui/PageTitle";

const ConversationDetail = () => {
    const { conversation, longDescription } = useLoaderData();

    return (
        <>
            <div className="page-div">
                <div className="title-area w-full">
                    <PageTitle
                        title="Conversations"
                        breadcrumb={[
                            { name: "home", path: "/" },
                            { name: "Conversations", path: "/conversation" },
                            { name: `${conversation.label}`, path: "" },
                        ]}
                    />
                </div>
                <div className="flex items-center h-[350px]">
                    <table className="datatable">
                        <tbody>
                        <tr key={conversation.conversationEntityId}>
                            <td
                                valign="top"
                                style={{ textAlign: "center", verticalAlign: "top" }}
                            >
                                <img
                                    src={`${process.env.PUBLIC_URL}/assets/images/img1.png`}
                                    alt="conImage"
                                />
                            </td>
                            <td valign="top" style={{ verticalAlign: "top" }}>
                                <h3 className="text-[18px] font-medium text-qblack mb-1.5 ml-4">
                                    {conversation.label}
                                </h3>
                                <ul>
                                    <li className="text-[15px] text-qgraytwo leading-7 mb-2.5 ml-4">
                                        {longDescription && (
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                    longDescription,
                                                }}
                                            />
                                        )}
                                    </li>
                                </ul>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default ConversationDetail;
